/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, jira/naming/disallow-filenames */
/* eslint-disable jira/naming/disallow-filenames */
/** @jsx jsx */

// eslint-disable-next-line jira/filename-case
import { css, jsx } from '@compiled/react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import type { JiraBoardType } from './__generated__/useBoardCreateMutationUseBoardCreateMutation.graphql.ts';
import { descriptionMapping } from './fireBoardCreateErrorAnalytics.tsx';

const boardCreationTitle = defineMessage({
	id: 'software-board-create.common.board-creation-title',
	defaultMessage: 'Create a board',
	description:
		'The title for both the board creation flyout menu that allows a user to pick between a creating a scrum or kanban board as well as the modal that opens after the user has made a selection',
});

const requiredFieldsHeader = defineMessage({
	id: 'software-board-create.common.required-fields-header',
	defaultMessage: 'Required fields are marked with an asterisk *',
	description: 'Description within header to explain required fields are marked with an asterisk',
});

export type ModalHeaderTypes = {
	type: JiraBoardType;
};

export const ModalHeader = ({ type }: ModalHeaderTypes): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.100">
			{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
			<h4 css={modalHeaderStyles}>{formatMessage(boardCreationTitle)}</h4>
			<Text size="medium" color="color.text.accent.gray.bolder">
				{descriptionMapping[type] && formatMessage(descriptionMapping[type])}
			</Text>
			<Text as="em" size="small" color="color.text.subtlest">
				{formatMessage(requiredFieldsHeader)}
			</Text>
		</Stack>
	);
};

const modalHeaderStyles = css({
	font: token('font.heading.medium'),
	fontWeight: token('font.weight.bold'),
	color: token('color.text'),
});
